import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { gcpAllAccountsSelector } from "./gcpAllAccountsSelector";
import { accountsSortBySelector } from "../slice-data/accountsSortBySelector";
import { accountsSortingCombiner } from "../../combiners/accountsSortingCombiner";

export const gcpSortedAccountsSelector = createDraftSafeSelector(
  [gcpAllAccountsSelector, accountsSortBySelector],
  accountsSortingCombiner,
);
